import { signout } from '@features/common';
import {
  $column,
  $config,
  $order,
  $sortingReady,
  setColumn,
  setConfig,
  setOrder,
  setSortingReady,
  SortToolbarGate,
} from '../model';
import { configFunc } from './config';
import { sortToolbarChangedFunc } from './sortToolbarChanged';
import { storage } from './storage';

$config.on(setConfig, (_, config) => config).reset([SortToolbarGate.close, signout]);

$column.on(setColumn, (_, column) => column).reset([SortToolbarGate.close, signout]);

$order.on(setOrder, (_, order) => order).reset([SortToolbarGate.close, signout]);

$sortingReady.on(setSortingReady, (_, sortingReady) => sortingReady).reset([SortToolbarGate.close, signout]);

configFunc();

sortToolbarChangedFunc();

storage();
